import { render } from "./StatisticsList.vue?vue&type=template&id=48b71b3c&scoped=true&ts=true"
import script from "./StatisticsList.vue?vue&type=script&lang=ts"
export * from "./StatisticsList.vue?vue&type=script&lang=ts"

import "./StatisticsList.vue?vue&type=style&index=0&id=48b71b3c&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b71b3c"]])

export default __exports__